import { useMarket } from "@app/_context";

import {
  isAdyenCheckoutEnabled,
  isWalleyCheckoutEnabled,
} from "@/config/checkout";

import Adyen from "./payment/adyen/Adyen";
import Walley from "./payment/walley/Walley";

export default function CheckoutPaymentMethods() {
  const marketConfig = useMarket().state.market;

  if (isAdyenCheckoutEnabled({ marketConfig })) {
    return <Adyen />;
  }

  if (isWalleyCheckoutEnabled({ marketConfig })) {
    return <Walley />;
  }

  return <span>Unknown checkout!</span>;
}
